import type { InternalAxiosRequestConfig } from 'axios';
import axios from 'axios';

const isGlobalZendesk = import.meta.env.VITE_APP_GLOBAL_ZENDESK === 'true';

const CropwiseElementAxiosInstance = axios.create();

const AuthApi = axios.create({
  baseURL: import.meta.env.VITE_APP_CROPWISE_AUTH,
});

const BaseApi = axios.create({
  baseURL: `${import.meta.env.VITE_APP_CROPWISE_BASE}/v2`,
});

const BaseApiV3 = axios.create({
  baseURL: `${import.meta.env.VITE_APP_CROPWISE_BASE}/v3`,
});

const ProtectorApi = axios.create({
  baseURL: `${import.meta.env.VITE_APP_PROTECTOR_API_URL}/v1`,
});

const RemoteSensingApi = axios.create({
  baseURL: `${import.meta.env.VITE_APP_REMOTE_SENSING}`,
});

const OperationsTilesApi = axios.create({
  baseURL: `${import.meta.env.VITE_APP_OPERATIONS_API_URL}`,
});

const ExplorerInsightsApi = axios.create({
  baseURL: `${import.meta.env.VITE_APP_SERVICE_EXPLORER_INSIGHTS}`,
});

const PrescriptionExportApi = axios.create({
  baseURL: `${import.meta.env.VITE_APP_PRESCRIPTION_EXPORT_API_URL}`,
});

const AnalyticsAPI = axios.create({ baseURL: `${import.meta.env.VITE_APP_BFF_ANALYTICS}` });

const PointsToMultipolygonAPI = axios.create({
  baseURL:
    import.meta.env.VITE_APP_POINTS_TO_MULTIPOLYGON_API_URL ||
    'https://points-to-multipolygon.api.planting.cropwise.com',
});

const ManagementZonesAPI = axios.create({
  baseURL:
    import.meta.env.VITE_APP_MANAGEMENT_ZONES_API_URL ||
    'https://batch-management-zones.api.planting.cropwise.com',
});

const AnalyticsValetAPI = axios.create({
  baseURL: `${import.meta.env.VITE_APP_ANALYTICS_VALET_API_URL}`,
});

const AnomalyDetectionAPI = axios.create({
  baseURL: `${import.meta.env.VITE_APP_ANOMALY_DETECTION_API_URL}`,
});

const NemaApi = axios.create({
  baseURL: `${import.meta.env.VITE_APP_CROPWISE_BASE}/api/cropwise/nemadigital/v1`,
});

const NemaExportApi = axios.create({
  baseURL: `${import.meta.env.VITE_APP_NEMA_EXPORT_API_URL}`,
});

const ZendeskApi = axios.create({
  baseURL: isGlobalZendesk
    ? 'https://cropwise-imagery.zendesk.com/api/v2'
    : 'https://farmshots.zendesk.com/api/v2',
});

const commonInterceptor = (config: InternalAxiosRequestConfig) => {
  const tokens = JSON.parse(localStorage.getItem('tokens') ?? 'null');
  if (tokens) {
    config.headers.Authorization = `Bearer ${tokens['access_token']}`;
  }
  return config;
};

AnalyticsAPI.interceptors.request.use(commonInterceptor);
PointsToMultipolygonAPI.interceptors.request.use(commonInterceptor);
ManagementZonesAPI.interceptors.request.use(commonInterceptor);
AnalyticsValetAPI.interceptors.request.use(commonInterceptor);
BaseApi.interceptors.request.use(commonInterceptor);
RemoteSensingApi.interceptors.request.use(commonInterceptor);
ExplorerInsightsApi.interceptors.request.use(commonInterceptor);
ProtectorApi.interceptors.request.use(commonInterceptor);
CropwiseElementAxiosInstance.interceptors.request.use(commonInterceptor);
BaseApiV3.interceptors.request.use(commonInterceptor);
AnomalyDetectionAPI.interceptors.request.use(commonInterceptor);
PrescriptionExportApi.interceptors.request.use(commonInterceptor);
NemaApi.interceptors.request.use(commonInterceptor);
NemaExportApi.interceptors.request.use(commonInterceptor);

export {
  AnalyticsAPI,
  AnalyticsValetAPI,
  AnomalyDetectionAPI,
  AuthApi,
  BaseApi,
  BaseApiV3,
  CropwiseElementAxiosInstance,
  ExplorerInsightsApi,
  ManagementZonesAPI,
  NemaApi,
  NemaExportApi,
  OperationsTilesApi,
  PointsToMultipolygonAPI,
  PrescriptionExportApi,
  ProtectorApi,
  RemoteSensingApi,
  ZendeskApi,
};
